import React, { useEffect, useRef, useState } from "react";
import {
  useTheme,
  CssBaseline,
  Box,
  Grid,
  Typography,
  Card,
  CardContent,
  TextField,
  MenuItem,
  FormControl,
  InputLabel,
  Select,
  Button,
  Chip,
  Stack,
  useMediaQuery,
  Avatar,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
} from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import ShieldOutlinedIcon from "@mui/icons-material/ShieldOutlined";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import axios from "axios";
import { baseapi } from "../Environmentalurl";
import { useSelector } from "react-redux";
import {
  ApplicationType,
  date,
  entity_id,
  getGeolocation,
  location,
  locationGeo,
  orderID,
  Platform,
} from "../Utils/Const";
import { useNavigate } from "react-router-dom";
import useIPAddress from "../Utils/useIPAddress";
import api from "../Utils/Api";

export default function Gas() {
  const theme = useTheme();
  const isDark = theme.palette.mode === "dark";
  const md = useMediaQuery("(min-width:900px)");

  const [billFetchEnabled, setBillFetchEnabled] = useState(false);
  const [billDetails, setBillDetails] = useState(null);
  const [tpinOpen, setTpinOpen] = useState(false);
  const [tpin, setTpin] = useState("");
  const [isVerifying, setIsVerifying] = useState(false);
  const [insufficientOpen, setInsufficientOpen] = useState(false);
  const [insufficientMsg, setInsufficientMsg] = useState("");
  const [successOpen, setSuccessOpen] = useState(false);
  // ── Charges summary ──────────────────────────────────────────────────────
  const [chargesLoading, setChargesLoading] = useState(false);
  const [chargesData, setChargesData] = useState(null);
  const [chargesOpen, setChargesOpen] = useState(false);

  // ── Payment result dialog ────────────────────────────────────────────────
  const [paymentResult, setPaymentResult] = useState({
    open: false,
    success: false,
    message: "",
  });
  const [openFetchDialog, setOpenFetchDialog] = useState(false);
  const [openPaymentDialog, setOpenPaymentDialog] = useState(false);
  const [paymentMessage, setPaymentMessage] = useState("");
  const [operators, setOperators] = useState([]);
  const [operator, setOperator] = React.useState("");
  const [dynamicFields, setDynamicFields] = useState([]);
  const [dynamicValues, setDynamicValues] = useState({});
  const [selectedOperatorData, setSelectedOperatorData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [selectedSubOption, setSelectedSubOption] = useState("");
  const bbpsUrls = useSelector((state) => state.auth.bbpsUrls);
  const GAS = bbpsUrls?.GAS;
  const inputRefs = useRef([]);
  // "https://taapp.transactionanalysts.com:444/OneApp/Json/BillAvenues/GAS.json";
  const ip = useIPAddress();
  useEffect(() => {
    const fetchBoards = async () => {
      if (!GAS) return; // wait till URL is available from redux

      try {
        setLoading(true);
        const response = await api.post(`${baseapi}/getbbpsservices`, {
          url: GAS,
        });

        if (Array.isArray(response.data)) {
          setOperators(response.data);
        } else {
          console.error("Unexpected operators response:", response.data);
        }
      } catch (err) {
        console.error("Error fetching LPG operators:", err);
      } finally {
        setLoading(false);
      }
    };

    fetchBoards();
  }, [GAS]);

  // ---------- HANDLE DYNAMIC FIELD CHANGE ----------
  const handleDynamicChange = (paramName, value) => {
    setDynamicValues((prev) => ({
      ...prev,
      [paramName]: value,
    }));
  };

  // ---------- FETCH BILL (ONLY FLOW FOR LPG) ----------
  const handleFetchOrPay = async () => {
    if (!operator) {
      alert("Please select an LPG Gas Provider!");
      return;
    }

    const board = operators.find((b) => b.Value === operator);
    if (!board) {
      alert("Invalid LPG operator selected.");
      return;
    }

    const Mobilenumber = JSON.parse(
      sessionStorage.getItem("mobileNumber") || "null",
    );
    const SessionID = JSON.parse(sessionStorage.getItem("SessionID") || "null");

    if (!Mobilenumber || !SessionID) {
      alert("Missing Mobile Number or Session ID in session storage.");
      return;
    }

    let Optional1 = [];
    let Optional2 = [];

    // CASE 1: Operator BHAR00000NATB4 (all text fields)
    if (selectedOperatorData?.Value === "BHAR00000NATB4") {
      const filledParams = dynamicFields.filter(
        (f) =>
          dynamicValues[f.paramName] &&
          dynamicValues[f.paramName].trim() !== "",
      );

      Optional1 = filledParams.map((p) => p.paramName);
      Optional2 = filledParams.map((p) => dynamicValues[p.paramName]);
    }

    // CASE 2: Other operators (dropdown + one textfield)
    else {
      if (!selectedSubOption) {
        alert("Please select one option");
        return;
      }

      const value = dynamicValues[selectedSubOption];

      if (!value || value.trim() === "") {
        alert(`Please enter value for ${selectedSubOption}`);
        return;
      }

      Optional1 = [selectedSubOption];
      Optional2 = [value];
    }

    const payload = {
      ReqType: "Jan_Aadhaar_eWallet_BBPSPayments",
      MachineID: ip,
      Mobilenumber,
      SessionID,
      Date: date,
      OrderId: orderID, // your generated orderID
      TPIN: "",
      RequestType: "BA_BBPS_Billfetch",
      Account_num: Mobilenumber,
      SpKey: board.Value,
      Amount: "1",
      Optional1,
      Optional2,
      Optional3: "true",
      Optional4: "",
      Optional5: "",
      Optional6: "",
      Optional7: "",
      Statement: "NOT_SUPPORTED",
      Narration: "",
      IsBillFetch: "",
      Platform: Platform,
      ApplicationType: ApplicationType,
      EntityID: entity_id,
      GeoLocation: locationGeo,
      ServiceID: "3",
      ParameterInfo: "",
    };

    console.log("📤 LPG Bill Fetch Request:", payload);

    try {
      const res = await api.post(
        `${baseapi}/JanAadhaareWalletBBPSPayments`,
        payload,
      );
      console.log("📥 LPG Bill Fetch Response:", res.data);

      setBillDetails(res.data);

      if (
        res.data.Response_Code === "2001" ||
        res.data.Message?.includes("Insufficient")
      ) {
        setInsufficientMsg(res.data.Message || "Insufficient Wallet Balance");
        setInsufficientOpen(true);
        return;
      }

      if (res.data.Response_Code === "1000") {
        // success - store for payment
        sessionStorage.setItem("orderID", res.data.OrderId);

        sessionStorage.setItem(
          "billFetchData",
          JSON.stringify({
            Mobilenumber,
            SessionID,
            orderID: res.data.OrderId,
            Account_num: Mobilenumber,
            CustomerID: Mobilenumber,
            SpKey: board.Value,
            Optional1,
            Optional2,
            billerResponseInfo: res.data.billerResponseInfo,
            billAmount: res.data.billAmount,
            billerName: res.data.billerName,
            customerName: res.data.customerName,
            dueDate: res.data.dueDate,
          }),
        );

        setOpenFetchDialog(true);
      } else {
        alert(res.data.Message || "Failed to fetch bill");
      }
    } catch (error) {
      console.error("❌ Error in LPG bill fetch:", error);
      alert("Failed to fetch bill. Please try again.");
    }
  };

  // ── Bill → GetCharges → show summary ──────────────────────────────────────
  const handleBillPayment = async () => {
    setOpenFetchDialog(false);
    setChargesLoading(true);
    const mobile = JSON.parse(sessionStorage.getItem("mobileNumber"));
    const session = JSON.parse(sessionStorage.getItem("SessionID"));
    const stored = JSON.parse(sessionStorage.getItem("billFetchData") || "{}");
    try {
      const chargesRes = await api.post(`${baseapi}/getbbpscharges`, {
        ReqType: "TA_BBPS_GetCharges",
        TrxnAmount: String(stored.billAmount || "0"),
        BillerID: selectedOperatorData?.Value || operator,
        EntityID: entity_id,
        MachineID: ip,
        ApplicationType: ApplicationType,
        Platform: Platform,
        GeoLocation: locationGeo,
        SessionID: session,
        Mobilenumber: mobile,
        ServiceID: "3",
      });
      const resData = chargesRes.data;
      if (resData?.Response_Code !== "1000" || !resData?.TotalPayable) {
        alert(
          resData?.Message || "Unable to calculate charges. Please try again.",
        );
        return;
      }
      setChargesData(resData);
      setChargesOpen(true);
    } catch {
      alert("Unable to calculate charges. Please try again.");
    } finally {
      setChargesLoading(false);
    }
  };

  // ── Charges confirmed → check wallet balance ──────────────────────────────
  const handleConfirmCharges = () => {
    setChargesOpen(false);
    validateBalanceAndProceed();
  };

  // ── Balance check (runs after GetCharges, before TPIN) ─────────────────────
  const validateBalanceAndProceed = async () => {
    try {
      const mobile = JSON.parse(sessionStorage.getItem("mobileNumber") || "null");
      const session = JSON.parse(sessionStorage.getItem("SessionID") || "null");
      const stored = JSON.parse(sessionStorage.getItem("billFetchData") || "{}");

      const requestBody = {
        ApplicationType: ApplicationType,
        EntityID: entity_id,
        GeoLocation: locationGeo,
        Mobilenumber: mobile,
        Platform: Platform,
        WalletTypeID: "1",
        ReqType: "Jan_Aadhaar_eWallet_Statement",
        SessionID: session,
        MachineID: ip,
        FromDate: "",
        ToDate: "",
      };

      const response = await api.post(
        `${baseapi}/JanAadhaareWalletStatement`,
        requestBody,
      );

      const { Info } = response.data;
      if (!Info || Info.length === 0) {
        alert("Unable to read wallet info.");
        return;
      }

      const walletBalance = parseFloat(Info[0].Balance);
      const rechargeAmount = parseFloat(
        chargesData?.TotalPayable ?? stored?.billAmount ?? 0,
      );

      if (walletBalance < rechargeAmount) {
        setInsufficientMsg(
          `Insufficient wallet balance. Amount payable is ₹${rechargeAmount}, but your wallet balance is ₹${walletBalance}.`,
        );
        setInsufficientOpen(true);
        return;
      }

      setTpin("");
      setTpinOpen(true);
    } catch (error) {
      alert("Unable to check wallet balance!");
    }
  };

  // ---------- VERIFY TPIN ----------
  const verifyTPIN = async () => {
    if (!tpin || tpin.length !== 4) {
      alert("Please enter valid 4-digit TPIN");
      return;
    }

    setIsVerifying(true);

    const mobileNumber = sessionStorage.getItem("mobileNumber");

    const tpinBody = {
      ReqType: "MT_TPIN_Management",
      Mobilenumber: mobileNumber,
      Statement: "ValidateTPIN",
      TPIN: tpin,
      OldTPIN: "",
      Platform: Platform,
      EntityID: entity_id,
      GeoLocation: locationGeo,
      MachineID: ip,
    };

    try {
      const tpinRes = await api.post(`${baseapi}/tpin`, tpinBody);
      console.log("TPIN RESPONSE:", tpinRes.data);

      if (tpinRes.data.Response_Code === "1692") {
        setTpinOpen(false);

        // Small delay for smooth UX
        setTimeout(() => {
          processFinalBillPayment();
        }, 300);
      } else {
        alert(tpinRes.data.Message || "Invalid TPIN");
      }
    } catch (err) {
      console.error("TPIN verification error:", err);
      alert("Server error in verifying TPIN");
    } finally {
      setIsVerifying(false);
      // optional: clear tpin
      // setTpin("");
    }
  };

  // ---------- FINAL PAYMENT (ProcessDebit) ----------
  const processFinalBillPayment = async () => {
    const storedData = JSON.parse(
      sessionStorage.getItem("billFetchData") || "{}",
    );
    const storedOrderId = sessionStorage.getItem("orderID");

    if (!storedData || !storedData.Mobilenumber || !storedOrderId) {
      alert("No bill data found for payment. Please fetch bill again.");
      return;
    }

    // ⚠️ Send the RAW base amount here, not chargesData.TotalPayable.
    // The payment API applies its own charges/GST on top of whatever
    // Amount it receives — sending it the already-charges-inclusive
    // TotalPayable causes it to add charges a second time, over-debiting
    // the wallet. TotalPayable is only for display and the balance check.
    const payableAmount = storedData?.billAmount;

    const payload = {
      ReqType: "Jan_Aadhaar_eWallet_BBPSPayments",
      MachineID: ip,
      Mobilenumber: storedData.Mobilenumber,
      SessionID: storedData.SessionID,
      Date: date,
      OrderId: storedOrderId,
      TPIN: tpin,
      RequestType: "BA_BBPS_PAYMENT",
      ParameterInfo: "Gas Bill Payment",
      IsExternalTransaction: "1",
      Account_num: storedData.Mobilenumber,
      CustomerID: storedData.Mobilenumber,
      SpKey: storedData.SpKey,
      Amount: payableAmount,
      Optional1: storedData.Optional1,
      Optional2: storedData.Optional2,
      Optional3: "true",
      Optional4: storedData.billerResponseInfo, // from bill fetch response
      Optional6: "NOT_SUPPORTED",
      Optional7: "",
      Platform: Platform,
      ApplicationType: ApplicationType,
      EntityID: entity_id,
      GeoLocation: locationGeo,
      Statement: "ProcessDebit",
      ServiceID: "3",
      Narration: `Payment of Rs. ${payableAmount} to Gas Bill`,
    };

    console.log("📤 LPG PAYMENT REQUEST:", payload);

    try {
      const payRes = await api.post(
        `${baseapi}/JanAadhaareWalletBBPSPayments`,
        payload,
      );
      console.log("📥 LPG PAYMENT RESPONSE:", payRes.data);

      if (payRes.data.Response_Code === "1000") {
        setPaymentResult({ open: true, success: true, message: "" });

        setTimeout(() => {
          window.location.href = "/dashboard";
        }, 1500);
      } else if (
        payRes.data.Response_Code === "2001" ||
        payRes.data.Message?.includes("Insufficient")
      ) {
        setInsufficientMsg(
          payRes.data.Message || "Insufficient Wallet Balance",
        );
        setInsufficientOpen(true);
      } else {
        setPaymentResult({
          open: true,
          success: false,
          message: payRes?.data?.Message || "Payment failed. Please try again.",
        });
      }
    } catch (error) {
      console.error("Payment error:", error);
      alert("Server error during payment");
    }
  };
  const navigate = useNavigate();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));

  return (
    <>
      <CssBaseline />
      <Box
        sx={{
          background: "#f8fafc",
          px: 6,
          transition: "background 0.4s ease",
          px: { xs: 2, md: 6 },
        }}
      >
        <Grid container spacing={3}>
          {/* Left Card */}
          <Grid size={{ xs: 12, md: 4 }} item xs={12} md={4}>
            <Card
              elevation={isDark ? 0 : 2}
              sx={{
                background: "white",
                borderRadius: 3,
                p: 2,
                boxShadow: "0 4px 12px rgba(0,0,0,0.04)",
                transition: "all 0.3s ease",
                border: "1px solid #f0f0f0",
              }}
            >
              <CardContent>
                <Typography
                  variant="h5"
                  sx={{
                    color: theme.palette.primary.main,
                    fontWeight: 700,
                    mb: 1,
                    fontSize: { xs: 15 },
                  }}
                >
                  Gas Bill Payment
                </Typography>

                <Typography
                  variant="body2"
                  color="text.secondary"
                  sx={{ mb: { md: 3 }, mt: { md: 4 } }}
                >
                  Select your gas service
                </Typography>

                {/* DTH Operator */}
                <FormControl fullWidth variant="filled" sx={{ mt: 1, mb: 2 }}>
                  <InputLabel>Select your gas service</InputLabel>
                  <Select
                    value={operator}
                    onChange={(e) => {
                      const val = e.target.value;
                      setOperator(val);
                      setChargesData(null);

                      const opData = operators.find((o) => o.Value === val);
                      setSelectedOperatorData(opData || null);

                      if (opData?.BBPSData) {
                        const fields = JSON.parse(opData.BBPSData);

                        // Only keep fields related to selected operator
                        const filtered = fields.filter(
                          (f) =>
                            f.operatorCode === opData.Value ||
                            fields.length === 1,
                        );

                        setDynamicFields(filtered);

                        const initial = {};
                        filtered.forEach((f) => {
                          initial[f.paramName] = "";
                        });
                        setDynamicValues(initial);
                      }
                    }}
                    sx={{
                      borderRadius: 1,
                      backgroundColor: "#f8fafc",
                      border: isDark ? "#12303a" : "1px solid #999",

                      "& .MuiFilledInput-root": {
                        backgroundColor: "#f8fafc",
                        border: isDark ? "#12303a" : "1px solid #999",
                        borderRadius: 1,
                      },
                    }}
                  >
                    <MenuItem value="">Select Gas Operator</MenuItem>

                    {operators.map((op, index) => (
                      <MenuItem key={index} value={op.Value}>
                        {op.Text}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>

                {/* Conditional Rendering */}
                {operator && (
                  <>
                    {/* Dynamic BBPSData fields */}
                    {dynamicFields.map((field, index) => (
                      <React.Fragment key={index}>
                        <Typography variant="caption" color="text.secondary">
                          {field.paramName}
                        </Typography>

                        <TextField
                          fullWidth
                          autoComplete="off"
                          placeholder={field.paramName}
                          variant="filled"
                          value={dynamicValues[field.paramName] || ""}
                          onChange={(e) =>
                            handleDynamicChange(field.paramName, e.target.value)
                          }
                          sx={{
                            mt: 1,
                            mb: 2,
                            backgroundColor: "#f8fafc",
                            borderRadius: 1,
                            "& .MuiFilledInput-root": {
                              backgroundColor: "#f8fafc",
                              border: isDark ? "#12303a" : "1px solid #999",
                              borderRadius: 1,
                            },
                          }}
                        />
                      </React.Fragment>
                    ))}

                    {/* Proceed Button */}
                    <Button
                      fullWidth
                      size="large"
                      endIcon={<ArrowForwardIcon />}
                      disabled={chargesLoading}
                      onClick={() => {
                        if (selectedOperatorData?.BillFetchEnabled) {
                          handleFetchOrPay(); // FETCH BILL FLOW
                        } else {
                          setTpinOpen(true); // QUICK PAY FLOW
                        }
                      }}
                      sx={{
                        background: "linear-gradient(135deg, #16a34a, #22c55e)",
                        color: "#fff",
                        borderRadius: 2,
                        py: 1.2,
                        fontWeight: 700,
                        textTransform: "none",
                        "&:hover": {
                          filter: "brightness(1.05)",
                        },
                      }}
                    >
                      {selectedOperatorData?.BillFetchEnabled
                        ? "Fetch Bill"
                        : "Quick Pay"}
                    </Button>
                  </>
                )}

                {/* Secure Info */}
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    gap: 1,
                    mt: 3,
                    color: "text.secondary",
                    mb: 1,
                  }}
                >
                  <ShieldOutlinedIcon
                    sx={{ color: theme.palette.primary.main }}
                  />
                  <Typography variant="body2">
                    100% Secure & Instant Recharge
                  </Typography>
                </Box>
              </CardContent>
            </Card>
          </Grid>

          {/* Right Card (unchanged) */}
          {!isMobile && (
            <>
              <Grid size={{ xs: 12, md: 8 }} item xs={12} md={8}>
                <Card
                  elevation={isDark ? 0 : 2}
                  sx={{
                    background: "white",
                    borderRadius: 3,
                    p: 2,
                    boxShadow: "0 4px 12px rgba(0,0,0,0.04)",
                    height: "100%",
                    transition: "all 0.3s ease",
                    border: "1px solid #f0f0f0",
                  }}
                >
                  <CardContent>
                    <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                      <Box
                        sx={{
                          width: 36,
                          height: 36,
                          borderRadius: 1.5,
                          background: isDark
                            ? "rgba(35,190,165,0.12)"
                            : "rgba(0,123,255,0.12)",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          color: theme.palette.primary.main,
                          mr: 1,
                        }}
                      >
                        <SearchIcon />
                      </Box>
                      <Typography
                        variant="h6"
                        sx={{ color: "text.primary", fontWeight: 700 }}
                      >
                        Browse Plans
                      </Typography>
                    </Box>

                    <Typography
                      variant="body2"
                      color="text.secondary"
                      sx={{ mt: 1 }}
                    >
                      Select an operator to see available plans
                    </Typography>

                    <Box
                      sx={{
                        background: isDark ? "#12303a" : "rgba(0,0,0,0.05)",
                        borderRadius: 2,
                        p: 3,
                        color: "text.secondary",
                        mt: 1,
                        mb: 2,
                        minHeight: 92,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                    >
                      <Typography>No plans available.</Typography>
                    </Box>

                    <Box
                      sx={{
                        background: isDark ? "#0f3a35" : "rgba(0,123,255,0.05)",
                        borderRadius: 1.5,
                        p: 1.2,
                        color: "text.secondary",
                        mt: 1,
                      }}
                    >
                      <Typography
                        sx={{
                          fontWeight: 600,
                          color: theme.palette.primary.main,
                        }}
                      >
                        Disclaimer:
                      </Typography>
                      <Typography variant="body2" sx={{ mt: 0.5 }}>
                        While we support most recharges, please verify with your
                        operator before proceeding.
                      </Typography>
                    </Box>
                  </CardContent>
                </Card>
              </Grid>

              <Grid size={{ xs: 12 }} item xs={12}>
                <Box
                  sx={{
                    borderRadius: md ? 2 : 0,
                    p: 1.5,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <Typography color="text.secondary">
                    Trusted by <b>UIDAI BBPS Network</b>
                  </Typography>
                </Box>
              </Grid>

              {/* Steps Section */}
            </>
          )}
        </Grid>
      </Box>
      <Dialog open={openFetchDialog} onClose={() => setOpenFetchDialog(false)}>
        <DialogTitle>Bill Details</DialogTitle>
        <DialogContent>
          <Typography>
            <b>Customer Name:</b> {billDetails?.customerName}
          </Typography>
          <Typography>
            <b>Biller Name:</b> {billDetails?.billerName}
          </Typography>
          <Typography>
            <b>Due Date:</b> {billDetails?.dueDate}
          </Typography>
          <Typography>
            <b>Amount:</b> ₹{billDetails?.billAmount}
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpenFetchDialog(false)}>Close</Button>
          <Button
            variant="contained"
            onClick={handleBillPayment}
            disabled={chargesLoading}
            sx={{
              background: "linear-gradient(90deg, #007BFF 0%, #00C9A7 100%)",
              color: "#fff",
            }}
          >
            {chargesLoading ? "Calculating charges..." : "Pay Now"}
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog
        open={insufficientOpen}
        onClose={() => setInsufficientOpen(false)}
        PaperProps={{
          sx: {
            borderRadius: 3,
            p: 1,
            width: 380,
          },
        }}
      >
        {/* HEADER */}
        <DialogTitle
          sx={{
            textAlign: "center",
            fontWeight: 600,
            fontSize: 18,
            pb: 0.5,
          }}
        >
          ⚠️ Insufficient Balance
        </DialogTitle>

        {/* MESSAGE */}
        <DialogContent sx={{ textAlign: "center", mt: 1 }}>
          <Typography sx={{ color: "text.secondary", fontSize: 14 }}>
            {insufficientMsg}
          </Typography>
        </DialogContent>

        {/* ACTIONS */}
        <DialogActions sx={{ px: 3, pb: 2 }}>
          <Button
            onClick={() => setInsufficientOpen(false)}
            fullWidth
            variant="outlined"
            sx={{
              borderRadius: 2,
              textTransform: "none",
              fontWeight: 500,
            }}
          >
            Cancel
          </Button>

          <Button
            fullWidth
            variant="contained"
            onClick={() => {
              setInsufficientOpen(false);
              navigate("/dashboard/loadmoney");
            }}
            sx={{
              borderRadius: 2,
              textTransform: "none",
              fontWeight: 600,
              ml: 1,
              color: "white",
            }}
          >
            Load Money
          </Button>
        </DialogActions>
      </Dialog>

      {/* TPIN Dialog */}
      <Dialog
        open={tpinOpen}
        onClose={() => setTpinOpen(false)}
        PaperProps={{
          sx: {
            width: 420,
            borderRadius: "20px",
            p: 3,
          },
        }}
      >
        <Typography textAlign="center" fontWeight={700} fontSize={18} mb={1}>
          Security Verification
        </Typography>

        <Typography
          textAlign="center"
          fontSize={13}
          color="text.secondary"
          mb={3}
        >
          Please enter your 4-digit TPIN to confirm this payment
        </Typography>

        <Box sx={{ display: "flex", gap: 1.5, justifyContent: "center" }}>
          {[0, 1, 2, 3].map((index) => (
            <TextField
              key={index}
              type="password"
              value={tpin[index] || ""}
              inputRef={(el) => (inputRefs.current[index] = el)}
              onChange={(e) => {
                const value = e.target.value.replace(/\D/g, "").slice(-1);

                const newTpin = tpin.padEnd(4, "").split("");
                newTpin[index] = value;

                setTpin(newTpin.join(""));

                // Move to next box automatically
                if (value && index < 3) {
                  inputRefs.current[index + 1]?.focus();
                }
              }}
              onKeyDown={(e) => {
                if (e.key === "Backspace" && !tpin[index] && index > 0) {
                  inputRefs.current[index - 1]?.focus();
                }
              }}
              inputProps={{
                maxLength: 1,
                style: {
                  textAlign: "center",
                  fontSize: "22px",
                  fontWeight: 600,
                },
              }}
              sx={{
                width: 60,
                "& .MuiOutlinedInput-root": {
                  height: 60,
                  borderRadius: 3,
                },
              }}
            />
          ))}
        </Box>

        <Box display="flex" gap={2}>
          <Button
            fullWidth
            onClick={() => setTpinOpen(false)}
            sx={{
              backgroundColor: "#f3f4f6",
              color: "#374151",
              borderRadius: 3,
              height: 48,
              textTransform: "none",
            }}
          >
            Cancel
          </Button>

          <Button
            fullWidth
            variant="contained"
            disabled={isVerifying || tpin.length !== 4}
            onClick={verifyTPIN}
            sx={{
              backgroundColor: "#ff4d4f",
              borderRadius: 3,
              height: 48,
              textTransform: "none",
            }}
          >
            {isVerifying ? "Verifying..." : "Confirm"}
          </Button>
        </Box>
      </Dialog>

      {/* ✅ Payment Response Dialog */}
      <Dialog open={successOpen}>
        <DialogTitle>🎉 Payment Successful!</DialogTitle>
        <DialogContent>
          <Typography>Your gas bill has been paid successfully.</Typography>
        </DialogContent>
      </Dialog>

      {/* ── CHARGES SUMMARY DIALOG ──────────────────────────────── */}
      <Dialog
        open={chargesOpen}
        onClose={() => setChargesOpen(false)}
        maxWidth="xs"
        fullWidth
        PaperProps={{
          sx: {
            borderRadius: "20px",
            overflow: "hidden",
            boxShadow: "0 24px 60px rgba(0,0,0,0.18)",
          },
        }}
      >
        <Box
          sx={{
            background: "linear-gradient(90deg, #007BFF 0%, #00C9A7 100%)",
            py: 3,
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            gap: 0.5,
            position: "relative",
            overflow: "hidden",
          }}
        >
          <Box
            sx={{
              position: "absolute",
              top: -20,
              right: -20,
              width: 80,
              height: 80,
              borderRadius: "50%",
              background: "rgba(255,255,255,0.08)",
            }}
          />
          <Typography sx={{ color: "#fff", fontWeight: 700, fontSize: 18 }}>
            Payment Summary
          </Typography>
          <Typography sx={{ color: "rgba(255,255,255,0.8)", fontSize: 12 }}>
            Review charges before proceeding
          </Typography>
        </Box>
        <DialogContent sx={{ px: 3, pt: 2.5, pb: 1 }}>
          {chargesData && (
            <Box sx={{ bgcolor: "#f5f7fb", borderRadius: 2, p: 2 }}>
              <Box display="flex" justifyContent="space-between" mb={1.2}>
                <Typography color="text.secondary" fontSize={14}>
                  Transaction Amount
                </Typography>
                <Typography fontWeight={600}>
                  ₹{chargesData.TransactionAmount}
                </Typography>
              </Box>
              <Box display="flex" justifyContent="space-between" mb={1.2}>
                <Typography color="text.secondary" fontSize={14}>
                  Charges
                </Typography>
                <Typography fontWeight={600}>₹{chargesData.Charges}</Typography>
              </Box>
              <Box
                display="flex"
                justifyContent="space-between"
                mb={1.2}
                pb={1.5}
                sx={{ borderBottom: "1px dashed #ccc" }}
              >
                <Typography color="text.secondary" fontSize={14}>
                  GST
                </Typography>
                <Typography fontWeight={600}>₹{chargesData.GST}</Typography>
              </Box>
              <Box display="flex" justifyContent="space-between" mt={1.5}>
                <Typography fontWeight={700} fontSize={16}>
                  Total Payable
                </Typography>
                <Typography
                  fontWeight={700}
                  fontSize={16}
                  sx={{ color: "#007BFF" }}
                >
                  ₹{chargesData.TotalPayable}
                </Typography>
              </Box>
            </Box>
          )}
        </DialogContent>
        <DialogActions sx={{ px: 3, pb: 3, pt: 1, gap: 1 }}>
          <Button
            onClick={() => setChargesOpen(false)}
            sx={{ textTransform: "none", borderRadius: 2 }}
          >
            Cancel
          </Button>
          <Button
            variant="contained"
            fullWidth
            size="large"
            onClick={handleConfirmCharges}
            sx={{
              textTransform: "none",
              borderRadius: 2,
              fontWeight: 700,
              background: "linear-gradient(90deg, #007BFF 0%, #00C9A7 100%)",
              boxShadow: "0 6px 16px rgba(0,123,255,0.3)",
            }}
          >
            Pay Now ₹{chargesData?.TotalPayable}
          </Button>
        </DialogActions>
      </Dialog>

      {/* ── PAYMENT RESULT DIALOG ───────────────────────────────── */}
      <Dialog
        open={paymentResult.open}
        onClose={() => setPaymentResult({ ...paymentResult, open: false })}
        maxWidth="xs"
        fullWidth
        PaperProps={{
          sx: {
            borderRadius: "20px",
            overflow: "hidden",
            boxShadow: "0 24px 60px rgba(0,0,0,0.18)",
          },
        }}
      >
        <Box
          sx={{
            background: paymentResult.success
              ? "linear-gradient(135deg, #16a34a, #22c55e)"
              : "linear-gradient(135deg, #dc2626, #b91c1c)",
            py: 3.5,
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            gap: 1,
          }}
        >
          <Typography sx={{ fontSize: 40 }}>
            {paymentResult.success ? "🎉" : "❌"}
          </Typography>
          <Typography sx={{ color: "#fff", fontWeight: 700, fontSize: 18 }}>
            {paymentResult.success ? "Payment Successful!" : "Payment Failed"}
          </Typography>
        </Box>
        <DialogContent sx={{ px: 3, pt: 2.5, pb: 1, textAlign: "center" }}>
          <Typography
            sx={{ fontSize: 14, color: "text.secondary", lineHeight: 1.6 }}
          >
            {paymentResult.success
              ? "Your bill has been paid successfully."
              : paymentResult.message}
          </Typography>
        </DialogContent>
        <DialogActions sx={{ px: 3, pb: 3, pt: 1 }}>
          <Button
            variant="contained"
            fullWidth
            size="large"
            onClick={() => {
              setPaymentResult({ ...paymentResult, open: false });
              if (paymentResult.success) window.location.href = "/dashboard";
            }}
            sx={{
              textTransform: "none",
              borderRadius: 2,
              fontWeight: 700,
              fontSize: 14,
              background: paymentResult.success
                ? "linear-gradient(135deg, #16a34a, #22c55e)"
                : "linear-gradient(135deg, #dc2626, #b91c1c)",
              boxShadow: paymentResult.success
                ? "0 4px 14px rgba(22,163,74,0.35)"
                : "0 4px 14px rgba(220,38,38,0.35)",
            }}
          >
            {paymentResult.success ? "Back to Dashboard" : "Try Again"}
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}